import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../../state';

import PersonalCalendarWidget from './index';

// Rationale for innerHeight - 300: the standalone widget is currently shown on
// a separate page in the user's personal rotas. We want it to take up the
// majority if the vertical space. 300 is a rough estimation of the height of
// the headers, tabs, navigation bar etc above the schedule.
const StandaloneWidget = props => (
  <Provider store={store}>
    <PersonalCalendarWidget {...props} autoResizeHeight={true} />
  </Provider>
);

export default StandaloneWidget;
